
import { computed, defineComponent, PropType } from 'vue'
import { AgreementSearchFilter } from '@/views/_shared/search-list/types'
import AgreementFormFieldStatus from '@/components/agreements/form-fields/filtering/status.vue'
import AgreementFormFieldType from '@/components/agreements/form-fields/filtering/type.vue'
import AgreementFormFieldOrganization from '@/components/agreements/form-fields/filtering/organization.vue'
import AgreementFormFieldName from '@/components/agreements/form-fields/filtering/name.vue'
import AgreementFormFieldId from '@/components/agreements/form-fields/filtering/id.vue'
import AgreementFormFieldDateFrom from '@/components/agreements/form-fields/filtering/date-from.vue'
import AgreementFormFieldDateTo from '@/components/agreements/form-fields/filtering/date-to.vue'
import AgreementFormFieldPackages from '@/components/agreements/form-fields/filtering/packages.vue'

export default defineComponent({
    name: 'agreements-filter',
    components: {
        AgreementFormFieldPackages,
        AgreementFormFieldStatus,
        AgreementFormFieldType,
        AgreementFormFieldOrganization,
        AgreementFormFieldName,
        AgreementFormFieldId,
        AgreementFormFieldDateFrom,
        AgreementFormFieldDateTo
    },
    props: {
        modelValue: {
            type: Object as PropType<AgreementSearchFilter>,
            required: true
        }
    },
    setup (props, { emit }) {
        const localModel = computed({
            get: () => props.modelValue,
            set: value => emit('update:modelValue', value)
        })

        return {
            localModel
        }
    }
})
